module.exports = __webpack_public_path__ + "static/media/002.a89db270.jpg";